import { gql } from 'apollo-boost';

export const CREATE_ADMIN_ARTIFACT_DIAGNOSTIC_EXPORT = gql`
    mutation CreateAdminArtifactDiagnosticExport($data: CreateAdminArtifactDiagnosticExportInput!) {
        createAdminArtifactDiagnosticExport(data: $data) {
            resultUrl
            expiresAt
            fileCount
        }
    }
`;
